module.exports = __webpack_public_path__ + "static/media/metamask.fbf33967.svg";